import RootCanal from './RootCanal';
export default RootCanal;